import { render } from "./HasilVerifikasi.vue?vue&type=template&id=2826baf9"
import script from "./HasilVerifikasi.vue?vue&type=script&lang=js"
export * from "./HasilVerifikasi.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__